import { create } from 'zustand';

export type ModalType =
    | 'wifi'
    | 'speaker'
    | 'rgb'
    | 'led_bar'
    | 'ir'
    | 'gps_distance'
    | 'variable'
    | 'func';

interface BlockModalState {
    isOpen: boolean;
    modalType: ModalType | null;
    onConfirm: (() => void) | null;

    openModal: (type: ModalType) => void;
    closeModal: () => void;
    setOnConfirm: (fn: () => void) => void;
}

export const useBlockModalStore = create<BlockModalState>((set) => ({
    isOpen: false,
    modalType: null,
    onConfirm: null,

    openModal: (type) => set({ isOpen: true, modalType: type, onConfirm: null }),
    closeModal: () => set({ isOpen: false, modalType: null, onConfirm: null }),
    setOnConfirm: (fn) => set({ onConfirm: fn }),
}));
